import { useSyncExternalStore } from "react";

/** Observable state for a service that outlives any one component: the engine, the
 * station, the session. React reads it through `useStore`. */
export class Store<S extends object> {
  private listeners = new Set<() => void>();

  constructor(private current: S) {}

  get state(): S {
    return this.current;
  }

  readonly subscribe = (listener: () => void): (() => void) => {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  };

  protected update(patch: Partial<S>): void {
    this.current = { ...this.current, ...patch };
    for (const listener of this.listeners) listener();
  }
}

export function useStore<S extends object>(store: Store<S>): S {
  return useSyncExternalStore(store.subscribe, () => store.state);
}
